export const randomItem = <T>(items: T[] | undefined | null) => {
  const arr = items || [];
  return arr[Math.floor(Math.random() * arr.length)];
};
